import { render, staticRenderFns } from "./IVAU.vue?vue&type=template&id=62677aee&scoped=true&"
import script from "./IVAU.vue?vue&type=script&lang=js&"
export * from "./IVAU.vue?vue&type=script&lang=js&"
import style0 from "./IVAU.vue?vue&type=style&index=0&id=62677aee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62677aee",
  null
  
)

export default component.exports